import { render, staticRenderFns } from "./custom-elem.vue?vue&type=template&id=6c31c04d&scoped=true"
import script from "./custom-elem.vue?vue&type=script&lang=js"
export * from "./custom-elem.vue?vue&type=script&lang=js"
import style0 from "./custom-elem.vue?vue&type=style&index=0&id=6c31c04d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c31c04d",
  null
  
)

export default component.exports